import { Pipe, PipeTransform } from '@angular/core';
import { PaymentMethod, PaymentMethodTranslations } from 'src/app/core/enums/payment-method.interface';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@Pipe({
    name: 'paymentMethod',
    pure: false
})
export class PaymentMethodPipe implements PipeTransform {

    constructor(private localizationService: LocalizationService) { }

    transform(value: PaymentMethod | string): string {
        if (!value) return '';

        const currentLang = this.localizationService.getCachedLanguage();
        return currentLang === 'ar'
            ? PaymentMethodTranslations[value as PaymentMethod] || value
            : value;
    }
}
